export enum INVITE_STATUS {
  LOADING,
  COMPLETED,
  DEFAULT,
}
